import { render, staticRenderFns } from "./AppointmentAddToCalendarConfirm.vue?vue&type=template&id=70329995&scoped=true&"
import script from "./AppointmentAddToCalendarConfirm.vue?vue&type=script&lang=ts&"
export * from "./AppointmentAddToCalendarConfirm.vue?vue&type=script&lang=ts&"
import style0 from "./AppointmentAddToCalendarConfirm.vue?vue&type=style&index=0&id=70329995&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70329995",
  null
  
)

export default component.exports